import { Pipe, PipeTransform } from '@angular/core';

import { EmojiSupportService } from '../emoji-support.service';

@Pipe({
  name: 'emojiFallbackHtml',
  standalone: true,
})
export class EmojiFallbackHtmlPipe implements PipeTransform {
  private fallbackRegex = this.emojiSupportService.fallbackRegex;

  constructor(private emojiSupportService: EmojiSupportService) {}

  public transform(html: string): string {
    if (!this.fallbackRegex) return html;

    return html.replace(this.fallbackRegex, (match: string, index: number) => {
      const fallbackUrl = this.emojiSupportService.getFallbackImgUrl(match);

      if (!fallbackUrl) return match;

      return `<span class="emoji-fallback" style="background-image: url('${fallbackUrl}'); overflow: hidden">${match}</span>`;
    });
  }
}
